import { type ModalRegistration } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { ConfirmMatchModal } from '../components/ConfirmMatchModal/ConfirmMatchModal';

/**
 * The module's dialog TYPES.
 *
 * Global strings, so they carry the module name: the registry throws on a
 * collision rather than letting whichever registered last silently win.
 */
export const TRUST_MODALS = {
  CONFIRM_MATCH: 'trust.confirm-match',
} as const;

/**
 * The registrations `app.config.tsx` installs.
 *
 * The queue opens this dialog by **string**, so the list never imports the
 * component that bans an account (W2) — and the payload is ids and two emails,
 * because `ModalData` is serializable-only and the dialog loads the rest from
 * its own query.
 */
export const trustModals: readonly ModalRegistration[] = [
  { modalTypes: [TRUST_MODALS.CONFIRM_MATCH], component: ConfirmMatchModal },
];
